import { useEffect } from "react"

import { useRecoilState } from "recoil"

import { userState } from "@fuse/recoil/signup"

import { auth } from "@firebaseConfig/clientApp"

import { devEmailVerificationUtils } from "@fuse/utils/DeviceDection"

/**
 * Custom hook to manage dev-only fake email verification
 * Automatically restores verification state from localStorage when user logs in
 */
export const useDevEmailVerification = () => {
  const [user, setUser] = useRecoilState(userState)

  useEffect(() => {
    const checkAndRestoreDevVerification = async () => {
      const currentUser = auth.currentUser
      if (!currentUser?.uid) return

      // Check if this user has fake verification stored
      const isDevVerified = devEmailVerificationUtils.isDevVerified(
        currentUser.uid,
      )
      const devEmail = devEmailVerificationUtils.getDevVerifiedEmail(
        currentUser.uid,
      )

      if (isDevVerified && devEmail) {
        console.log("🔄 DEV: Restoring fake email verification state")

        // Update user state to reflect dev verification
        setUser((prev) => ({
          ...prev,
          email: devEmail,
          emailVerified: true,
        }))

        console.log("✅ DEV: Email verification state restored")
      }
    }

    // Check for dev verification when the hook mounts or when user changes
    if (user?.uid) {
      checkAndRestoreDevVerification()
    }
  }, [user?.uid, setUser])

  // Function to clear dev verification on logout
  const clearDevVerificationOnLogout = () => {
    const currentUser = auth.currentUser
    if (currentUser?.uid) {
      devEmailVerificationUtils.clearDevVerification(currentUser.uid)
    }
  }

  return {
    clearDevVerificationOnLogout,
  }
}
